var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 12.7V58.5H68.9V12.7C68.9 9.6 71.4 7 74.4 7C77.4 7 79.9 9.6 79.9 12.7V58.5H89.8V12.7C89.8 9.6 92.3 7 95.3 7C98.3 7 100.8 9.6 100.8 12.7V58.5H115.2C118.4 58.5 120.9 60.9 120.9 64C120.9 67 118.3 69.5 115.2 69.5H100.8V115.3C100.8 118.4 98.3 121 95.3 121C92.3 121 89.8 118.4 89.8 115.3V69.5H79.9V115.3C79.9 118.4 77.4 121 74.4 121C71.4 121 68.9 118.4 68.9 115.3V69.5H59V115.3C59 118.4 56.5 121 53.5 121C50.5 121 48 118.4 48 115.3V69.5H38.1V115.3C38.1 118.4 35.6 121 32.6 121C29.6 121 27.1 118.4 27.1 115.3V69.5H12.7C9.5 69.5 7 67 7 64C7 61 9.5 58.5 12.7 58.5H27.1V12.7C27.1 9.6 29.6 7 32.6 7C35.6 7 38.1 9.6 38.1 12.7V58.5H48.1V12.7C48.1 9.6 50.6 7 53.6 7C56.6 7 59 9.6 59 12.7Z",
    fill: "#F5333F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUob);
export default __webpack_public_path__ + "static/media/uob - ธนาคารยูโอบี.447cad84069f3b9d8b0e1d11ef6d3c65.svg";
export { ForwardRef as ReactComponent };